import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { signIn } from "../../api/sessions";
import history from "../../history";
import { loginUser } from "../../redux/actions";
import { connect } from "react-redux";
import { NavBar, Seo } from "../shared";
import { Link, Redirect } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import { roleBasedUrl } from "../../helpers";
import * as yup from "yup";
import { Segment } from "semantic-ui-react";
import { ForgotPasswordInline } from "./ForgotPassword";
import { Modal as ModalExample } from "../shared";

class SignInForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            forgot_password: false,
            change_password: false,
            message: null,
            loginError: null,
        };
    }

    setLoading = (value) => {
        this.setState({
            loading: value,
        });
    };

    toggleState = (key) => {
        this.setState((prevState) => ({
            [key]: !prevState[key],
        }));
    };

    componentDidMount() {}

    render() {
        const { currentUser } = this.props;
        const {
            loading,
            forgot_password,
            change_password,
            message,
            loginError,
        } = this.state;
        var redirectUrl = "/";
        const UsersSigninForm = yup.object().shape({
            email: yup.string().email().required("Required"),
            password: yup.string().required("Required"),
        });
        // Group/Shared/Private pages send ?return=... via window.location.href; state.from is set only when using React Router Link
        const searchParams = new URLSearchParams(this.props.location.search || "");
        const returnParam = searchParams.get("return");
        if (returnParam && returnParam.startsWith("/")) {
            redirectUrl = returnParam;
        } else if (this.props.location.state?.from?.pathname) {
            redirectUrl = this.props.location.state.from.pathname;
        }
        // if (currentUser.email !== undefined) {
        // 	return <Redirect to={redirectUrl} />;
        // }
        const locationHash = this.props.location.hash || "";
        if (locationHash.includes("#change_password")) {
            const hashQuery = locationHash.replace(/^#change_password\??/, "").replace(/^\?/, "");
            const token = new URLSearchParams(hashQuery).get("reset_token");
            if (token) {
                return <Redirect to={"/reset-password?token=" + encodeURIComponent(token)} />;
            }
        }
        return (
            <div className="login-page-wrapper full-page">
                <Seo title="Log In" path="/login" noindex />
                <Formik
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                    validationSchema={UsersSigninForm}
                    onSubmit={async (values, { setSubmitting, setStatus }) => {
                        this.setState({
                            loading: true,
                        });
                        const variables = {
                            user: {
                                email: values.email,
                                password: values.password,
                            },
                        };
                        this.setState({ loginError: null });
                        signIn(variables)
                            .then((response) => {
                                setSubmitting(false);
                                if (response.data.sign_in_count == 0) {
                                    history.push(
                                        `/reset-password?token=${response.data.reset_token}`
                                    );
                                }
                                if (response.data.user !== undefined) {
                                    this.props.loginUser(response.data.user);
                                    var path = roleBasedUrl(
                                        response.data.user.role,
                                        redirectUrl
                                    );
                                    this.setState({
                                        message: response.data.message,
                                        loginError: null,
                                    });
                                    history.push(path);
                                } else {
                                    this.setState({ loading: false });
                                }
                                this.setState({
                                    loading: false,
                                });
                            })
                            .catch((error) => {
                                const errMsg =
                                    (error.response && error.response.data && error.response.data.errors && error.response.data.errors[0]) ||
                                    (error.response && error.response.data && error.response.data.message) ||
                                    "Log in failed. Please check your email and password.";
                                this.setState({
                                    loading: false,
                                    loginError: errMsg,
                                });
                                setSubmitting(false);
                            });
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        /* and other goodies */
                    }) => (
                        <Segment loading={loading} className="login-segment">
                            <div className="login-form-card">
                                <div className="login-form-card-body">
                                    {this.props.location.state?.resetSuccess && (
                                        <div className="alert alert-success mb-3" role="alert">
                                            Password reset successfully. Please sign in with your new password.
                                        </div>
                                    )}
                                    {!forgot_password ? (
                                        <>
                                    <h2 className="login-title">Welcome back</h2>
                                    <p className="login-subtitle">Sign in to continue to Visit All Nepal</p>

                                    <div className="login-google-hero">
                                        <SocialLinks
                                            redirectUrl={redirectUrl}
                                            setLoading={(status) =>
                                                this.setLoading(status)
                                            }
                                        />
                                    </div>

                                    <div className="login-divider">
                                        <span>or sign in with email</span>
                                    </div>

                                    {loginError && (
                                        <div className="alert alert-danger mb-3" role="alert">
                                            {loginError}
                                        </div>
                                    )}

                                    <form
                                        onSubmit={handleSubmit}
                                        className="form-wrap mt-3"
                                    >
                                        <div className="fields">
                                            <div className="field">
                                                <label>Email</label>
                                                <Field
                                                    type="text"
                                                    name="email"
                                                    className="form-control"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.email}
                                                    placeholder="Email"
                                                />
                                                <ErrorMessage name="email" />
                                            </div>
                                            <div className="field">
                                                <label>Password</label>
                                                <Field
                                                    type="password"
                                                    name="password"
                                                    className="form-control"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.password}
                                                    placeholder="Password"
                                                />
                                                <ErrorMessage name="password" />
                                            </div>
                                            <div
                                                className="text-small cursor-pointer mb-2"
                                                onClick={() =>
                                                    this.toggleState(
                                                        "forgot_password"
                                                    )
                                                }
                                            >
                                                Forgot Password?
                                            </div>
                                        </div>
                                        <button
                                            className="btn btn-secondary my-2 w-100"
                                            type="submit"
                                            disabled={isSubmitting}
                                        >
                                            Sign In
                                        </button>
                                        <p className="login-create-account-footer mt-3 mb-0">
                                            New to Visit All Nepal?{" "}
                                            <Link to={{ pathname: "/signup", state: { from: redirectUrl } }}>
                                                Create account
                                            </Link>
                                        </p>
                                    </form>
                                        </>
                                    ) : (
                                        <ForgotPasswordInline
                                            onBack={() => this.toggleState("forgot_password")}
                                            redirectUrl={redirectUrl}
                                        />
                                    )}
                                </div>
                            </div>
                        </Segment>
                    )}
                </Formik>

            </div>
        );
    }
}

const mapStateToProps = ({ userStore }) => {
    return {
        currentUser: userStore.currentUser,
    };
};

const mapDispatchToProps = {
    loginUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInForm);
